import React from 'react';

export const SvgLinkedIn = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5514 2H3.50762C2.69238 2 2 2.64476 2 3.43905V20.56C2 21.3552 2.45429 22 3.26952 22H20.3133C21.1295 22 22 21.3552 22 20.56V3.43905C22 2.64476 21.3676 2 20.5514 2ZM9.61905 9.61905H12.3114V10.9914H12.341C12.7514 10.2514 13.9638 9.5 15.4629 9.5C18.34 9.5 19.1429 11.0276 19.1429 13.8571V19.1429H16.2857V14.3781C16.2857 13.1114 15.78 12 14.5971 12C13.1609 12 12.4762 12.9724 12.4762 14.5686V19.1429H9.61905V9.61905ZM4.85714 19.1429H7.71429V9.61905H4.85714V19.1429ZM8.07143 6.28571C8.07143 7.27238 7.27238 8.07143 6.28571 8.07143C5.29905 8.07143 4.5 7.27238 4.5 6.28571C4.5 5.29905 5.29905 4.5 6.28571 4.5C7.27238 4.5 8.07143 5.29905 8.07143 6.28571Z"
      fill="#2867B2"
    />
  </svg>
);
